import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { ApiConnectService } from '../../../../services/api-connect.service';
import {
  MorningOvertimeHeadSetting,
  MorningOvertimeHeadSettingUpdateRequest,
  MorningOvertimeReadinessAnswer,
  MorningOvertimeReadinessState,
  MorningOvertimeReadinessSubmitRequest
} from '../models/morning-overtime-readiness.model';

@Injectable()
export class MorningOvertimeReadinessApiService {
  constructor(
    private http: HttpClient,
    private apiConnectService: ApiConnectService
  ) {}

  public getPromptState(): Observable<MorningOvertimeReadinessState> {
    return this.http.get<MorningOvertimeReadinessState>(
      this.apiConnectService.morningOvertimeReadinessState
    );
  }

  public submitAnswer(
    request: MorningOvertimeReadinessSubmitRequest
  ): Observable<MorningOvertimeReadinessAnswer> {
    return this.http.post<MorningOvertimeReadinessAnswer>(
      this.apiConnectService.morningOvertimeReadinessAnswers,
      request
    );
  }

  public getHeadSetting(mainGroupId: string): Observable<MorningOvertimeHeadSetting> {
    return this.http.get<MorningOvertimeHeadSetting>(
      this.apiConnectService.morningOvertimeHeadGroupSettings +
      mainGroupId +
      '/morning-overtime-readiness/settings'
    );
  }

  public updateHeadSetting(
    mainGroupId: string,
    request: MorningOvertimeHeadSettingUpdateRequest
  ): Observable<MorningOvertimeHeadSetting> {
    return this.http.put<MorningOvertimeHeadSetting>(
      this.apiConnectService.morningOvertimeHeadGroupSettings +
      mainGroupId +
      '/morning-overtime-readiness/settings',
      request
    );
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/common/morning-overtime-readiness/services/morning-overtime-readiness-api.service.ts